import createBox from '../createBox';
const Box = createBox();
export default Box;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/Box/Box.js
// module id = 893
// module chunks = 1